import React from "react"
import { injectIntl } from "react-intl"
import BaseNoResult from "../../common/no-result/BaseNoResult"
import IntlProps from "../../state/helpers/IntlProps"
import { messages } from "./messages"


const NoPaymentsProcessed = (props: IntlProps) => {

    return <BaseNoResult 
        title={props.intl.formatMessage(messages["NoPaymentsProcessedTitle"])}
        description={props.intl.formatMessage(messages["NoPaymentsProcessedDescription"])}
        displayImage={true}
        image={<img src="/images/Credit-card.svg" width="70px" alt="Payment cards" />}
    />
}

export default injectIntl(NoPaymentsProcessed)


// WEBPACK FOOTER //
// ./src/payment-processing/payment-listing/NoPaymentsProcessed.tsx